import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AddCompany() {
  const navigate = useNavigate();
  useEffect(() => { navigate("/companies", { replace: true }); }, [navigate]);
  return null;
}